/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Update Campsite Label Schema
 * @export
 * @interface UpdateCampsiteLabelRequest
 */
export interface UpdateCampsiteLabelRequest {
    /**
     * Campsite Label GeoJSON
     * @type {string}
     * @memberof UpdateCampsiteLabelRequest
     */
    campsiteLabelGeojson: string;
}

/**
 * Check if a given object implements the UpdateCampsiteLabelRequest interface.
 */
export function instanceOfUpdateCampsiteLabelRequest(value: object): value is UpdateCampsiteLabelRequest {
    if (!('campsiteLabelGeojson' in value) || value['campsiteLabelGeojson'] === undefined) return false;
    return true;
}

export function UpdateCampsiteLabelRequestFromJSON(json: any): UpdateCampsiteLabelRequest {
    return UpdateCampsiteLabelRequestFromJSONTyped(json, false);
}

export function UpdateCampsiteLabelRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCampsiteLabelRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'campsiteLabelGeojson': json['campsite_label_geojson'],
    };
}

export function UpdateCampsiteLabelRequestToJSON(value?: UpdateCampsiteLabelRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'campsite_label_geojson': value['campsiteLabelGeojson'],
    };
}

